import {ErrorWrapper, ResponseWrapper} from '@/core/service/util'
import {RoomBaseApiService} from "@/core/service/room.baseapi.service";

class RoomMirroringService extends RoomBaseApiService {
  constructor() {
    super()
  }

  async sendEvent(data) {
    try {
      const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/mirroring/sendEvent`, data)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}

export const roomMirroringService = new RoomMirroringService()